export default "__VITE_ASSET__69efd143__"